import React, { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import PruFilter, { PruFilterItemType } from 'src/app/common/components/PruTable/PruFilter';
import { PaginateList } from 'src/app/common/types/common-types';
import { useDataProvider } from 'src/app/common/utils';
import { fetchList, MdrtStoryListParams } from '../../../network/mdrtStoryCrud';
import { MdrtStoryItem, PublishStatus } from '../../../types/mdrt-story-types';
import MdrtStoryList from './components/MdrtStoryList';

type MdrtListingPageProps = {} & ParamsProps;

export const filterKeys = ['agentCode', 'title'];

const initialState: MdrtStoryListParams = {
  agentCode: '',
  title: '',
  page: 1,
  limit: 5,
};

const paramsInitiator = (initialParams?: Record<string, string>): MdrtStoryListParams => {
  return initialParams
    ? {
        agentCode: initialParams.agentCode ?? '',
        title: initialParams.title ?? '',
        page: 1,
        limit: 5,
      }
    : initialState;
};

const MdrtStoryListingPage: FC<MdrtListingPageProps> = ({ initialParams, onChangeQueryParams }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const dispatch = useDispatch();

  const [filterState, setFilterState] = useState<MdrtStoryListParams>(paramsInitiator(initialParams));
  const [itemList, setItemList] = useState<PaginateList<MdrtStoryItem>>();

  const { isLoading, refreshData } = useDataProvider<PaginateList<MdrtStoryItem>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }
        return await fetchList(filterState, dispatch);
      } catch (err) {}
    },
    setItemList,
    false,
  );

  return (
    <>
      <PruFilter
        title={Translation('mdrtHub.mdrtStory.filter')}
        itemDef={[
          {
            type: PruFilterItemType.FREE_TEXT,
            field: 'agentCode',
            initialValue: filterState.agentCode,
            displayName: Translation('app.filter.agentCode'),
          },
          {
            type: PruFilterItemType.FREE_TEXT,
            field: 'title',
            initialValue: filterState.title,
            displayName: Translation('mdrtHub.mdrtStory.filter.title'),
          },
        ]}
        onChangeFilter={(data) =>
          setFilterState({
            ...filterState,
            agentCode: data.agentCode,
            title: data.title,
          })
        }
        fetchData={refreshData}
      />
      <MdrtStoryList
        isLoading={isLoading}
        onRefresh={refreshData}
        itemList={itemList}
        onChangePage={(page, rowsPerPage) => {
          setFilterState({
            ...filterState,
            page,
            limit: rowsPerPage,
          });
          refreshData();
        }}
      />
    </>
  );
};

export default MdrtStoryListingPage;
